<template>
  <div class="empty-state__container">
    <img v-if="stringSet.image"
         :src="stringSet.image.src"
         :alt="stringSet.image.alt"
         :class="{'mb-l': stringSet.image.margin}">

    <h3 class="Title4 mb-l"
        v-if="stringSet.stringHeader">
      {{ stringSet.stringHeader }}
    </h3>

    <p class="mb-m Body1 gray-200"
       :class="stringSet.subHeader1Class"
       v-if="stringSet.subHeader1">
      {{ stringSet.subHeader1 }}
    </p>
    <p v-if="stringSet.subHeader2"
       v-html="stringSet.subHeader2"
       class="Body1 gray-900">
    </p>
  </div>
</template>

<script>
  import Appointments from '@/assets/images/empty-states/appointments.png';
  import Bills from '@/assets/images/empty-states/bills.png';
  import Doctors from '@/assets/images/empty-states/doctors.png';
  import Prescription from '@/assets/images/empty-states/ico049.svg';
  import RecordsAll from '@/assets/images/empty-states/ico044.svg';
  import RecordsPrescriptions from '@/assets/images/empty-states/ico049.svg';
  import RecordsLabTests from '@/assets/images/empty-states/ico050.svg';
  import GetElementString from '@/mixins/get-element-string';

  export default {
    name: 'EmptyState',
    mixins: [GetElementString],
    props: {
      type: {type: String, required: true},
      variant: {type: String, default: 'empty'}
    },
    data() {
      return {
        stringConstants: {
          appointments: {
            image: {
              src: Appointments,
              alt: 'No consultations found',
              margin: true
            },
            // stringHeader: 'No appointment request found.',
            subHeader1: this.getElementString('txt008'),
            subHeader2: `<a class="Hyperlink2 dodgerBlue" href="https://nowserving.ph/" target="_blank">Find a Doctor</a> and book a consultation now`,
            subHeader1Class: 'compact',
          },
          doctors: {
            image: {
              src: Doctors,
              alt: 'No doctors found',
              margin: true
            },
            // stringHeader: 'No doctors on your list yet.',
            subHeader1: this.getElementString('txt288'),
            subHeader2: `<a class="Hyperlink2 dodgerBlue" href="https://nowserving.ph/" target="_blank">Find a Doctor</a> and book a consultation now`,
            subHeader1Class: 'compact',
          },
          bills: {
            image: {
              src: Bills,
              alt: 'No bills found',
              margin: true
            },
            stringHeader: 'No bills sent your list yet.',
            subHeader1: 'All bills sent to you by your doctors will be shown here',
          },
          recordsAll: {
            image: {
              src: RecordsAll,
              alt: 'No files found',
              margin: false
            },
            // stringHeader: 'No files shared with you',
            subHeader1: this.variant === 'empty' ? this.getElementString('txt075') : this.getElementString('txt138'),
            subHeader1Class: this.variant === 'empty' ? 'compact' : ''
          },
          recordsPrescriptions: {
            image: {
              src: RecordsPrescriptions,
              alt: 'No files found',
              margin: false
            },
            // stringHeader: 'No files shared with you',
            subHeader1: this.variant === 'empty' ? this.getElementString('txt075') : this.getElementString('txt138'),
            subHeader1Class: this.variant === 'empty' ? 'compact' : ''
          },
          recordsLabTests: {
            image: {
              src: RecordsLabTests,
              alt: 'No files found',
              margin: false
            },
            // stringHeader: 'No files shared with you',
            subHeader1: this.variant === 'empty' ? this.getElementString('txt075') : this.getElementString('txt138'),
            subHeader1Class: this.variant === 'empty' ? 'compact' : ''
          },
          messages: {
            stringHeader: 'No messages found.',
            subHeader1: 'All message shared with your doctors will be shown here.',
          },
          prescription: {
            image: {
              src: Prescription,
              margin: true
            },
            subHeader1: 'Once doctors have sent Prescriptions to your app, you can choose them here',
          }
        }
      }
    },
    computed: {
      stringSet() {
        return this.stringConstants[this.type];
      },
    },
  }
</script>

<style lang="scss" scoped>
  .empty-state__container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    text-align: center;
    margin: auto;

    .compact {
      padding: 0 space(xxxl);
    }

    img {
      pointer-events: none;
      width: 180px;
    }

  }
</style>